export const MAX_NAME_LENGTH = 64;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export function isValidEmail(value) {
    const s = value.trim();
    return s.length > 0 && EMAIL_PATTERN.test(s);
}

export function isValidName(value) {
    const s = value.trim();
    return s.length >= 1 && s.length <= MAX_NAME_LENGTH;
}
